// @mui
import { Slider, Typography, Stack, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
// hooks
import useSettings from '../../../hooks/useSettings';

// ----------------------------------------------------------------------

const RootStyle = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(1, 1),
}));

// ----------------------------------------------------------------------

export default function SettingFontSize() {
  const { themeFontSize, onChangeFontSize } = useSettings();

  return (
    <RootStyle>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
        <Typography variant="overline" sx={{ color: 'text.secondary' }}>
          Size
        </Typography>
        <Box
          sx={{
            py: 0.25,
            px: 1,
            borderRadius: 0.75,
            bgcolor: 'grey.800',
            color: 'common.white',
            typography: 'caption',
            fontWeight: 'bold',
          }}
        >
          {themeFontSize}px
        </Box>
      </Stack>

      <Slider
        min={12}
        max={24}
        value={themeFontSize}
        onChange={onChangeFontSize}
        valueLabelDisplay="auto"
        sx={{
          '& .MuiSlider-thumb': {
            width: 16,
            height: 16,
          },
        }}
      />
    </RootStyle>
  );
}
